/**
 * SA 本人が自分の契約 (saOnboarding) を参照し、更新を申請するためのフック。
 * - 自分の admins/{uid} は Firestore Rules で本人 read 可。
 * - 更新申請は requestSaRenewal Callable (admins write は owner 限定のため)。
 */
import type { Admin, SaOnboarding } from '@goenhub/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';


import { db, functions } from '@/lib/firebase';

export function useMySaOnboarding(uid: string | null | undefined) {
  return useQuery({
    queryKey: ['my_sa_onboarding', uid],
    enabled: !!uid,
    queryFn: async (): Promise<SaOnboarding | null> => {
      if (!uid) return null;
      const snap = await getDoc(doc(db, 'admins', uid));
      if (!snap.exists()) return null;
      const a = snap.data() as Admin;
      if (a.dept !== 'sales' || a.level !== 'external') return null;
      return a.saOnboarding ?? null;
    },
  });
}

const requestSaRenewalFn = httpsCallable<unknown, { ok: true }>(
  functions,
  'requestSaRenewal',
);

export function useRequestSaRenewal() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await requestSaRenewalFn({})).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my_sa_onboarding'] }),
  });
}
